





























import { index } from '@/api/mini_program_wechat_pays'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {}
})

export default class extends Vue {
  screening: Record<string, any> = {
    status: 0
  }

  config: Record<string, any> = {
    api: index,
    paginate: true,
    include: 'store',
    fields: [
      { prop: 'id', label: '#', width: 60 },
      { prop: 'applyment_id', label: '申请编号' },
      { prop: 'merchant_name', label: '主体' },
      { prop: 'store', label: '门店', slot: true },
      { prop: 'contact_mobile', label: '联系电话', slot: true, width: 120 },
      { prop: 'status', label: '状态', slot: true, width: 100 },
      { prop: 'applyment_state_msg', label: '错误信息' },
      { prop: 'created_at', label: '申请时间', width: 150 }
    ]
  }
}
